import { BrowserView, MobileView } from "react-device-detect";
import { SelectAccountDesktop } from "./selectAccountDesktop";
import { SelectAccountMobile } from "./selectAccountMobile";

export const LoginSelectAccount = () => {
  return (
    <>
      <BrowserView>
        <SelectAccountDesktop></SelectAccountDesktop>
      </BrowserView>
      <MobileView>
        <SelectAccountMobile></SelectAccountMobile>
      </MobileView>
    </>
  );
};
